export interface Taxonomy {
    id: string;
    name: string;
    spreeId: string | undefined;
    parentId: string | null;
    depth: number;
    permalink: string;
    children: Taxonomy[];
}

export interface TaxonomyLink {
  id: string
  spreeId: string | undefined
  text: string
  route: string
  links: TaxonomyLink[]
}

export interface TaxonomyHeader {
  headers: {text: string}[]
  links: TaxonomyLink[]
}
